import axios from "vue-app/utils/axios";
import { Chat } from "vue-app/components/Onsite/Chat/chat.types.ts";

export { getChatConfig, postUpdateChatConfig, postPreviewChat, postPublishChat };

async function getChatConfig() {
  const response = await axios.get("/json/chat/get-chat-config");
  return response.data;
}

async function postUpdateChatConfig(chatList: Chat[]) {
  const response = await axios.post("/json/external/update_tracker_external_configuration", {
    external_configuration_parameter_type_id: 54,
    value: chatList,
    trackerId: window.EDRONE_CONTEXT.trackerId,
  });
  return response.data;
}

async function postPreviewChat(chatIndex: number, chatConfig: Chat[]) {
  const response = await axios.post("/chat/set_chat_preview", {
    type: "chat",
    chatIndex,
    chatConfig,
  });
  return response.data;
}

async function postPublishChat() {
  await axios.post("/json/external/update_tracker_external_configuration", {
    external_configuration_parameter_type_id: 55,
    value: "true",
    trackerId: window.EDRONE_CONTEXT.trackerId,
  });
  await axios.post("/json/external/setPublish", {
    type: "chat",
  });
}
